import React from 'react';
import { Eye, EyeOff } from 'lucide-react';
import type { FloorPlanUnderlay } from '../../../types';
import { underlayIsHidden } from './floorPlanMath';

interface FloorPlanLayersProps {
  underlays: FloorPlanUnderlay[];
  selectedId?: string | null;
  onSelect: (id: string) => void;
  onToggleHidden: (id: string) => void;
}

const FloorPlanLayers: React.FC<FloorPlanLayersProps> = ({
  underlays,
  selectedId,
  onSelect,
  onToggleHidden,
}) => {
  const layers = underlays.slice().reverse();

  return (
    <aside className="fp-layers" aria-label="Image layers">
      <div className="fp-layers-kicker">Layers</div>
      {layers.length === 0 ? (
        <div className="fp-layers-empty">No images yet.</div>
      ) : (
        <ul className="fp-layers-list">
          {layers.map((underlay) => {
            const hidden = underlayIsHidden(underlay);
            const active = selectedId === underlay.id;
            return (
              <li key={underlay.id}>
                <button
                  type="button"
                  className={`fp-layers-item${active ? ' is-active' : ''}${hidden ? ' is-hidden' : ''}`}
                  onClick={() => onSelect(underlay.id)}
                >
                  <span className="fp-layers-name">{underlay.label || 'Image'}</span>
                </button>
                <button
                  type="button"
                  className="fp-layers-eye"
                  title={hidden ? 'Show layer' : 'Hide layer'}
                  aria-label={hidden ? `Show ${underlay.label || 'image'}` : `Hide ${underlay.label || 'image'}`}
                  aria-pressed={hidden}
                  onClick={() => onToggleHidden(underlay.id)}
                >
                  {hidden ? <EyeOff size={14} /> : <Eye size={14} />}
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </aside>
  );
};

export default FloorPlanLayers;
